<template>
<div class="dashboard-page create-campaign">
	<div class="dash-navbar">
		<h4>
			Create Campaign:
			<span>01. Select Opportunity 02. Choose Layout 03. Add elements</span>
			<span>Drag & Drop</span>
		</h4>
	</div>
	<div class="template-list">
		<div class="search-template">
			<custom-input
				type="text"
				placeholder="Search"
				iconClass="icon-search"
				inputStyle="light"
				v-model="templateSearch"
			/>
		</div>
		<ul>
			<li v-for="(item, index) in templates" :key="index">
				<router-link :to="'/template/' + item.id">{{ item.name }}</router-link>
				<p>{{ item.sector.name + ' | ' + item.region.name }}</p>
				<p>{{ 'Added ' + item.created_at }}</p>
			</li>
		</ul>
	</div>
	<site-builder />
</div>
</template>

<script>
import CustomInput from '@/components/secondary/CustomInput'
import SiteBuilder from './components/SiteBuilder'
import { mapActions, mapState } from 'vuex'

export default {
	components: {
		CustomInput,
		SiteBuilder
	},
	data: () => ({
		templateSearch: '',
		templateList: [
			{
				name: 'Block Z-38 Farm-In (Offshore)',
				sector: 'Oil & Gas (Farm-In)',
				region: 'Tumbies Basin',
				createdAt: '18 July 2019'
			},
			{
				name: 'Lima International Conference & Exhibition Centre',
				sector: 'Culture & Arts',
				region: 'Lima',
				createdAt: '17 July 2019'
			},
			{
				name: 'Block 11-A (Onshore)',
				sector: 'Oil & Gas (Licensing Round)',
				region: 'Cusco Province',
				createdAt: '08 July 2019'
			},
			{
				name: 'Lima International Conference & Exhibition Centre',
				sector: 'Culture & Arts',
				region: 'Lima',
				createdAt: '17 July 2019'
			},
			{
				name: 'Block 11-A (Onshore)',
				sector: 'Oil & Gas (Licensing Round)',
				region: 'Cusco Province',
				createdAt: '08 July 2019'
			}
		]
	}),
	created() {
		this.getTemplates()
	},
	computed: {
		...mapState({
			templates: ({ TemplateStore }) => TemplateStore.list,
		})
	},
	methods: {
		...mapActions({
			getTemplates: 'TemplateStore/getList'
		})
	}
}
</script>

<style lang="scss">
.create-campaign {
	.dash-navbar {
		padding: 21px 30px;
		background: #f7f7f7;
		position: absolute;
		left: 0px;
		right: 0;

		h4 {
			margin: 0;
			text-align: left;
			color: #4ba98b;
			font-weight: 500;

			span {
				color: #000;
				font-size: 13px;
				margin-left: 5px;

				&:last-child {
					float: right;
				}
			}
		}
	}
	.template-list {
		width: 270px;
		position: absolute;
		top: 61px;

		.search-template {
			.custom-input {
				i {
					left: 5px;
					top: 9px;
					font-size: 26px;
				}
				input {
					background: #fff;
					padding: 16px 16px 16px 50px;
					margin: 0;
					font-size: 14px;
					font-weight: 400;
	
					&::placeholder {
						color: #a9a9a9;
						font-size: 15px;
						font-weight: 400;
					}
				}
			}
		}
		ul {
			margin: 0;
			padding: 0;
			list-style: none;

			li {
				text-align: left;
				padding: 25px 10px 25px 35px;
				height: 60px;
				
				&:nth-child(odd) {
					background: #ededed;
				}

				a {
					margin: 0;
					color: #4d4d4d;
					font-size: 15px;
					font-weight: 500;
					text-decoration: none;

					&:hover {
						text-decoration: underline;
					}
				}
				p {
					color: #606060;
					font-size: 11px;
					margin: 0;
				}
			}
		}
	}
}
</style>
